import type { Area } from "react-easy-crop"

export const cropImage = async (
  imageSrc: string,
  pixelCrop: Area,
  outputWidth = 400,
  /** Defaults to `outputWidth` — the square canvas every caller had before spec 10. */
  outputHeight = outputWidth,
  /** PNG keeps an alpha channel (a transparent logo); JPEG is every other caller's default. */
  outputType: "image/jpeg" | "image/png" = "image/jpeg"
): Promise<Blob> => {
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image()
    img.addEventListener("load", () => resolve(img))
    img.addEventListener("error", (e) => reject(e))
    img.crossOrigin = "anonymous"
    img.src = imageSrc
  })
  const canvas = document.createElement("canvas")
  const ctx = canvas.getContext("2d")!

  canvas.width = outputWidth
  canvas.height = outputHeight

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputWidth,
    outputHeight
  )

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) resolve(blob)
        else reject(new Error("Canvas toBlob failed"))
      },
      outputType,
      0.92
    )
  })
}
